import { render, staticRenderFns } from "./BaseSpacerWithRuler.vue?vue&type=template&id=f9e9f6a6"
import script from "./BaseSpacerWithRuler.vue?vue&type=script&lang=js"
export * from "./BaseSpacerWithRuler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports